import React from 'react';
import { Box, Flex, Heading, Text, Icon } from '@chakra-ui/react';
import { MdLogin } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const WelcomeHeader = () => {
    const { t } = useTranslation();

    return (
        <Box
            bg="#f6f3ec"
            py="2px"  // Altezza
            px="10px"
            w="100%"
            position="sticky"
            top="70px"
            zIndex="999"
        >
            <Flex align="center" justify="space-between">
                <Heading fontFamily="inherit" fontWeight="bold" color="green.400">
                    {t('guestArea.guestHome.welcomeToAmelia')}
                </Heading>

                <Link to="/login">
                    <Flex
                        as="button"
                        align="center"
                        gap={2}
                        bg="#0b4e5a"
                        color="green.400"
                        px={3}
                        py={1}
                        borderRadius="md"
                        cursor="pointer"
                    >
                        <Text fontSize="sm" fontWeight="bold">
                            {t('navbarGuestArea.privateArea')}
                        </Text>
                        <Icon as={MdLogin} w={5} h={5} />
                    </Flex>
                </Link>
            </Flex>

            <hr style={{ borderTop: '2px solid #0b4e5a' }} />
        </Box>
    );
};

export default WelcomeHeader;
